/**
 * Product Card Add to Cart
 * Handles inline variant selection and add to cart on product cards
 */
(function() {
  'use strict';

  var SELECTORS = {
    productItem: '.product-item',
    variantButtons: '[data-variant-buttons]',
    variantBtn: '[data-variant-btn]',
    atcContainer: '[data-product-item-atc]',
    addToCartBtn: '[data-add-to-cart-btn]',
    btnText: '[data-btn-text]',
    variantJson: '[data-product-variants]',
    cartIcon: '[data-js-cart-icon]',
    cartCount: '[data-js-cart-count]',
    quickCartWrapper: '.quick-cart__wrapper',
    quickCartContainer: '.quick-cart__container',
    quickCartItems: '.quick-cart__items',
    quickCartCount: '.quick-cart__heading sup',
    quickCartSubtotal: '.quick-cart__footer-subtotal span',
    quickCartDiscounts: '.quick-cart__item-discounts',
    quickCartFooter: '.quick-cart__footer'
  };

  function init() {
    var productItems = document.querySelectorAll(SELECTORS.productItem);
    
    productItems.forEach(function(productItem) {
      initProductItem(productItem);
    });
  }

  function initProductItem(productItem) {
    // Skip if already initialized
    if (productItem.dataset.atcInitialized === 'true') return;
    
    var variantButtonsContainer = productItem.querySelector(SELECTORS.variantButtons);
    var atcContainer = productItem.querySelector(SELECTORS.atcContainer);
    
    if (!atcContainer) return;

    // Mark as initialized
    productItem.dataset.atcInitialized = 'true';
    
    var variantButtons = variantButtonsContainer 
      ? Array.from(variantButtonsContainer.querySelectorAll(SELECTORS.variantBtn))
      : [];
    var addToCartBtn = atcContainer.querySelector(SELECTORS.addToCartBtn);
    var btnText = addToCartBtn ? addToCartBtn.querySelector(SELECTORS.btnText) : null;
    var variantJsonEl = atcContainer.querySelector(SELECTORS.variantJson);
    var hasVariants = atcContainer.dataset.hasVariants === 'true';
    
    var variants = [];
    if (variantJsonEl) {
      try {
        variants = JSON.parse(variantJsonEl.textContent);
      } catch (e) {
        console.error('Error parsing variants JSON', e);
      }
    }

    // Handle variant button clicks
    if (hasVariants && variantButtons.length) {
      variantButtons.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          var optionValue = btn.dataset.optionValue;

          // Remove selected class from all buttons in this container only
          variantButtons.forEach(function(b) {
            b.classList.remove('selected');
          });

          // Add selected class to clicked button
          btn.classList.add('selected');

          // Find matching variant
          var matchingVariant = variants.find(function(v) {
            return v.option1 === optionValue;
          });

          if (matchingVariant && addToCartBtn && btnText) {
            addToCartBtn.dataset.variantId = matchingVariant.id;
            
            if (matchingVariant.available) {
              addToCartBtn.disabled = false;
              addToCartBtn.classList.remove('btn--sold-out');
              btnText.textContent = addToCartBtn.dataset.langAdd || 'Add to Bag';
            } else {
              addToCartBtn.disabled = true;
              addToCartBtn.classList.add('btn--sold-out');
              btnText.textContent = addToCartBtn.dataset.langUnavailable || 'Sold Out';
            }
          }
        });
      });
    }

    // Handle add to cart button click
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var variantId = addToCartBtn.dataset.variantId;
        if (!variantId || addToCartBtn.disabled) return;

        addToCartBtn.classList.add('loading');

        // Add to cart and handle the quick cart
        addToCart(variantId, 1, addToCartBtn);
      });
    }
  }

  function addToCart(variantId, quantity, button) {
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: quantity
      })
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Add to cart failed');
      }
      return response.json();
    })
    .then(function(item) {
      // Get updated cart data
      return fetch('/cart.js', {
        method: 'GET',
        credentials: 'include'
      })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        return { item: item, cart: cart };
      });
    })
    .then(function(result) {
      button.classList.remove('loading');
      button.classList.add('success');
      
      // Update header cart counts
      updateCartCounts(result.cart.item_count);
      
      // Refresh quick cart HTML, then trigger the theme's cart icon click
      refreshQuickCartThenOpen();
      
      setTimeout(function() {
        button.classList.remove('success');
      }, 1500);
    })
    .catch(function(error) {
      button.classList.remove('loading');
      console.error('Error adding to cart:', error);
    });
  }

  function updateCartCounts(count) {
    // Update all cart count elements in the header
    var cartCounts = document.querySelectorAll(SELECTORS.cartCount);
    cartCounts.forEach(function(el) {
      el.textContent = count;
    });
  }

  function refreshQuickCartThenOpen() {
    var quickCart = document.querySelector('.quick-cart');
    if (!quickCart) {
      // No quick cart, just click the cart icon
      triggerCartIconClick();
      return;
    }

    // Fetch the updated quick cart section
    var url = (window.theme && window.theme.routes && window.theme.routes.cart && window.theme.routes.cart.base) 
      ? window.theme.routes.cart.base + '?section_id=quick-cart'
      : '/cart?section_id=quick-cart';

    fetch(url)
      .then(function(response) { return response.text(); })
      .then(function(html) {
        // Parse the response
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        
        var responseContainer = doc.querySelector(SELECTORS.quickCartContainer);
        var currentContainer = quickCart.querySelector(SELECTORS.quickCartContainer);
        
        var currentHasItems = Boolean(quickCart.querySelector(SELECTORS.quickCartItems));
        var responseHasItems = Boolean(doc.querySelector(SELECTORS.quickCartItems));

        if (responseHasItems && currentHasItems) {
          // Update specific parts like the theme does
          updateInnerHTML(SELECTORS.quickCartItems, doc, quickCart);
          updateInnerHTML(SELECTORS.quickCartCount, doc, quickCart);
          updateInnerHTML(SELECTORS.quickCartSubtotal, doc, quickCart);
          updateInnerHTML(SELECTORS.quickCartDiscounts, doc, quickCart);
          
          // Adjust padding
          adjustItemPadding(quickCart);
        } else if (responseContainer && currentContainer) {
          // Replace entire container content (empty to items or items to empty)
          currentContainer.innerHTML = responseContainer.innerHTML;
        }

        // Now trigger the cart icon click to open the quick cart using theme's native handler
        triggerCartIconClick();
      })
      .catch(function(error) {
        console.error('Error refreshing quick cart:', error);
        // Still try to open even if refresh failed
        triggerCartIconClick();
      });
  }

  function updateInnerHTML(selector, sourceDoc, targetContainer) {
    var sourceEl = sourceDoc.querySelector(selector);
    var targetEl = targetContainer.querySelector(selector);
    
    if (sourceEl && targetEl) {
      targetEl.innerHTML = sourceEl.innerHTML;
    }
  }

  function adjustItemPadding(quickCart) {
    var items = quickCart.querySelector(SELECTORS.quickCartItems);
    var footer = quickCart.querySelector(SELECTORS.quickCartFooter);
    
    if (items && footer) {
      items.style.paddingBottom = footer.clientHeight + 'px';
    }
  }

  function triggerCartIconClick() {
    // Find the cart icon and click it to trigger the theme's native quick cart open
    var cartIcon = document.querySelector(SELECTORS.cartIcon);
    if (cartIcon) {
      cartIcon.click();
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize when collection is updated (filtering, infinite scroll)
  document.addEventListener('collection:updated', function() {
    setTimeout(function() {
      var productItems = document.querySelectorAll(SELECTORS.productItem);
      productItems.forEach(function(productItem) {
        initProductItem(productItem);
      });
    }, 100);
  });

  // Also listen for Shopify section events
  document.addEventListener('shopify:section:load', function() {
    setTimeout(init, 100);
  });
})();
